import { render, staticRenderFns } from "./MemberCodEdit.vue?vue&type=template&id=1990c674&scoped=true&"
import script from "./MemberCodEdit.vue?vue&type=script&lang=js&"
export * from "./MemberCodEdit.vue?vue&type=script&lang=js&"
import style0 from "./MemberCodEdit.vue?vue&type=style&index=0&id=1990c674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990c674",
  null
  
)

export default component.exports